<template>
    <a class="ts-finder__pdf-button" href="#" rel="nofollow" @click="downloadClicked" ref="downloadPdfButton">
        <span class="ts-finder__pdf-button-normal"><i class="fas fa-file-pdf"></i> {{strings['TsFinder.Map.PdfDownload']}}</span>
        <span class="ts-finder__pdf-button-active"><i class="fas fa-circle-notch fa-spin"></i> {{strings['TsFinder.Map.PdfPreparing']}}</span>
    </a>
</template>

<script>
    import { mapState } from 'vuex'
    import $ from 'jQuery'
    import FileSaver from 'file-saver'

    export default {
        computed: {
            ...mapState([
                'filteredStations',
                'strings'
            ])
        },
        methods: {
            async downloadClicked(ev) {
                ev.preventDefault();

                const btn = $(this.$refs.downloadPdfButton);
                if (btn.hasClass('disabled')) {
                    return;
                }
                btn.addClass('disabled', true);

                $('.ts-finder__pdf-button-normal').hide();
                $('.ts-finder__pdf-button-active').show();

                var data = {
                    "ids": this.filteredStations.map(station => station.id).join(',')
                };

                const response = await fetch('/migrolapi/' + window.CONFIG.language + '/tankstellenpdf', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(data),
                    responseType: 'blob'
                });

                if (response.ok) {
                    const filename = response.headers.get('content-disposition')
                        .split(';')
                        .find((element) => element.includes('filename='))
                        .replace('filename=', '')
                        .trim();

                    const blob = await response.blob();
                    FileSaver.saveAs(blob, filename);
                }

                // re-enable the button
                $('.ts-finder__pdf-button-normal').show();
                $('.ts-finder__pdf-button-active').hide();
                btn.removeClass('disabled');
            }
        }
    };
</script>